import { render, staticRenderFns } from "./TermsAcceptanceModal.vue?vue&type=template&id=1f7e0efb"
import script from "./TermsAcceptanceModal.vue?vue&type=script&lang=js"
export * from "./TermsAcceptanceModal.vue?vue&type=script&lang=js"
import style0 from "./TermsAcceptanceModal.vue?vue&type=style&index=0&id=1f7e0efb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports